import React from "react";
import nube from "../assets/images/sidom/svg/Recurso 26Nube-neg.svg";
import nube2 from "../assets/images/sidom/svg/Recurso 25Nube-pos.svg";
import logo from "../assets/images/icons/sidom.svg";

export default function GlobalTrade() {
  return (
    <div className="  border border-sidom-light dark:border-sidom-blue  text-sidom-light dark:text-sidom-light">
      <div className="flex container  flex-col gap-2 px-2 md:px-0 lg:px-0  mt-[100px]    text-center">
        <div className="flex flex-col md:flex-row mb-3 justify-center  items-center gap-2">
          <img src={logo} className="h-8" alt="Logo Sidom" />
          <h1 className="text-3xl font-bold text-sidom-dark  dark:text-sidom-light">
            Global Trade
          </h1>
        </div>

        <p className="text-2xl md:text-3xl lg:text-4xl p-1 md:p-1 lg:p-0 font-bold text-sidom-dark  dark:text-sidom-light mb-3">
          El poder de la integración 4PL
        </p>

        <p className="text-xs sm:text-sm md:text-base lg:text-xl text-sidom-dark    dark:text-sidom-light max-w-xl mx-auto">
          La única plataforma 100% Web/SaaS para la gestión punta a punta de la
          operatoria de importadores y exportadores.
        </p>
        <div className="container ">
          <div className="w-full flex justify-center lg:p-0 items-center  mt-[60px] ">
            <img
              src={nube}
              className="hidden dark:block  w-[800px] "
              alt="Imagen modo oscuro"
            />
            <img
              src={nube2}
              className="block dark:hidden w-[800px] "
              alt="Imagen modo claro"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
